/**
 * UI-related translations for Spanish language
 * This file contains translations for common UI elements
 */
export default {
  startPanel: {
    copyLink: 'Copiar enlace',
    discord: 'Discord',
    leaveGame: 'Salir del juego',
    joinGame: 'Unirse al juego',
    lockGame: 'Bloquear juego',
    unlockGame: 'Desbloquear juego',
    startGame: 'Iniciar juego',
    options: 'Opciones',
  },
  onlineStatus: {
    connecting: 'Conectando...',
    connected: 'Conectado',
    error: 'Error',
  },
  profile: {
    username: 'Nombre de usuario',
    stats: 'Estadísticas',
    logout: 'Cerrar sesión',
    language: 'Idioma',
    hideSpoilersHint: 'Ocultar spoilers',
    hideIndexHint: 'Ocultar índices en el historial',
    animeMode: 'Modo anime',
    update: 'Actualizar',
    colorTheme: 'Tema de color',
    darkTheme: 'Tema oscuro',
    lightTheme: 'Tema claro',
    profile: 'Perfil',
    settings: 'Configuración',
    change: 'Cambiar',
    changePassword: 'Cambiar contraseña',
  },
  breadCrumbs: {
    merlin: 'Merlín',
    merlin_pure: 'Merlín Puro',
    guinevere: 'Ginebra',
    percival: 'Percival',
    lovers: 'Amantes',
    troublemaker: 'Problematizador',
    servant: 'Servidor',
    lancelots: 'Lancelotes',
    mordred: 'Mordred',
    trickster: 'Tramposo',
    revealer: 'Revelada',
    morgana: 'Morgana',
    oberon: 'Oberón',
    lunatic: 'Lunático',
    brute: 'Bruto',
    witch: 'Bruja',
    minion: 'Secuaz',
    cleric: 'Clérigo',
    wiki: 'Wiki',
    expansions: 'Expansiones',
    roles: 'Roles',
    lady: 'Dama',
    lady_sea: 'Dama del Mar',
    plot_cards: 'Cartas de trama',
    excalibur: 'Excalibur',
    rules: 'Reglas',
  },
  hostMenu: {
    host: 'Anfitrión',
    hostPanel: 'Panel del anfitrión',
    endRestartGameHint: 'Los botones iniciarán la votación para finalizar o reiniciar el juego',
    endGame: 'Finalizar juego',
    restartGame: 'Reiniciar juego',
    shuffle: 'Mezclar',
    shuffleHint: 'Mezclar las posiciones de los jugadores en el vestíbulo',
  },
  cardsInfo: {
    cards: 'Cartas',
    usedCards: 'Cartas Usadas',
    remainingCards: 'Cartas Restantes',
    leadToVictory: 'Liderar hacia la Victoria',
    leadToVictoryHint: 'Conviértete en líder antes de seleccionar el equipo',
    ambush: 'Emboscada',
    ambushHint: 'Revela el resultado de una carta de misión',
    kingReturns: 'El Rey Regresa',
    kingReturnsHint: 'Cancelar una misión aprobada y pasar el liderazgo al siguiente jugador',
    restoreHonor: 'Restaura tu Honor',
    restoreHonorHint: 'Toma una carta de trama de cualquier jugador',
    charge: 'Acusación',
    chargeHint: 'Obliga a un jugador a votar públicamente',
    showNature: 'Muestra tu Verdadera Naturaleza',
    showNatureHint: 'Revela tu lealtad a otro jugador',
    areYouTheOne: '¿Eres el Elegido?',
    areYouTheOneHint: 'Verifica la lealtad de un jugador adyacente',
    weFoundYou: 'Te Encontramos',
    weFoundYouHint: 'Obliga a un jugador a jugar su carta de misión boca arriba',
    showStrength: 'Muestra tu Fuerza',
    showStrengthHint: 'El líder revela su lealtad a un jugador',
  },
  avatars: {
    modalHeader: 'Seleccionar avatar',
    servantHint: 'Avatar predeterminado',
    lady_of_lakeHint: 'Otorgado a los usuarios registrados en 2025',
    mysteryHint: 'Otorgado a los usuarios que encuentran el secreto en el sitio',
    merlin_pureHint: 'Otorgado por ayudar al proyecto con comentarios / ayudar a encontrar errores',
    'anime/merlin_pureHint': 'Otorgado por hacer cualquier contribución al código del proyecto en GitHub',
    'anime/witchHint': 'Otorgado por alcanzar el primer puesto en cualquier rol',
  },
  spoiler: {
    spoiler: 'Spoiler',
    spoilerHint:
      'El contenido está oculto bajo el spoiler, ya que contiene información desconocida para otros jugadores',
  },
  previewLink: {
    'Minions of Mordred(*)': 'Esbirros de Mordred(*)',
    Minions: 'Esbirros',
  },
  chartStats: {
    countPlayer: '{playerCount} jugadores',
    evilWinrate: 'Tasa de victoria del Lado del Mal',
    goodWinrate: 'Tasa de victoria del Lado del Bien',
    winrateByTeamSize: 'Tasa de victorias por tamaño del equipo',
    halfWinrate: '50% tasa de victoria',
  },
  inGame: {
    sendTeam: 'Enviar equipo',
    approve: 'Aprobar',
    reject: 'Rechazar',
    success: 'Éxito',
    fail: 'Fallar',
    checkLoyalty: 'Verificar lealtad',
    giveExcalibur: 'Dar Excalibur',
    skipExcalibur: 'Omitir Excalibur',
    useExcalibur: 'Usar Excalibur',
    useWitchAbility: 'Ocultar misión',
    skipWitchAbility: 'Omitir',
    giveCard: 'Dar carta',
    takeLead: 'Tomar liderazgo',
    skip: 'Omitir',
    useCard: 'Usar {cardName}',
    skipCard: 'Omitir {cardName}',
    selectPlayer: 'Seleccionar un jugador',
    selectSinglePlayer: 'Por favor, seleccione solo un jugador',
    cannotSelectSelf: 'No puedes seleccionarte a ti mismo',
    takeCard: 'Tomar carta',
    selectCard: 'Seleccionar una carta',
    noAvailableCards: 'No hay cartas disponibles',
    revealLoyalty: 'Revelar Lealtad',
  },
};
